module.exports = __webpack_public_path__ + "static/media/019.99bf5454.png";